export const LEAD_DROP_POPUP_2_CONSTANTS = {
  DEFAULT_ROW: {
    // Header / Title section
    form_title: "",
    form_title_color: "#000000",
    end_date: "",
    end_time: "",
    gradient_start: "#BE2330",
    gradient_end: "#8B0000",
    date_number_color: "#000000",
    date_text_color: "#666666",
    date_background_color: "#F5F5F5",
    close_icon: "",
    close_icon_alt: "Close",
    title_2: "",
    title_2_color: "#000000",
    description: "",
    description_color: "#666666",
    // Step 1 button
    button_step_1_text: "Sign Up",
    button_step_1_text_color: "#FFFFFF",
    button_background_color: "#BE2330",
    // Step 2 button
    button_step_2_text: "Continue",
    button_step_2_text_color: "#FFFFFF",
    button_step_2_background_color: "#BE2330",
    // Step 3 button
    button_step_3_text: "Submit",
    button_step_3_text_color: "#FFFFFF",
    button_step_3_background_color: "#BE2330",
    // Checkbox
    checkbox_color: "#BE2330",
    checkbox_description: "",
    checkbox_description_color: "#666666",
    // OTP section
    otp_header_text: "",
    otp_header_text_color: "#000000",
    otp_header_description: "",
    otp_header_description_color: "#666666",
    edit_number_text: "Edit",
    edit_number_text_color: "#BE2330",
    otp_title: "",
    otp_title_color: "#000000",
    resend_otp_text: "Resend OTP",
    resend_otp_text_color: "#BE2330",
    otp_description_text: "",
    otp_description_text_color: "#666666",
    // New user section
    new_user_title: "",
    new_user_title_color: "#000000",
    new_user_subtitle: "",
    new_user_subtitle_color: "#666666",
    new_user_description: "",
    new_user_description_color: "#666666",
    new_user_button_text: "Continue",
    new_user_button_text_color: "#FFFFFF",
    new_user_button_background_color: "#BE2330",
    new_user_button_icon: "",
    new_user_background_image: "",
    new_user_background_image_alt: "New user section background",
    success_button_link: "",
    // Existing user section
    existing_user_title: "",
    existing_user_title_color: "#000000",
    existing_user_subtitle: "",
    existing_user_subtitle_color: "#666666",
    existing_user_description: "",
    existing_user_description_color: "#666666",
    existing_user_button_text: "Continue",
    existing_user_button_text_color: "#FFFFFF",
    existing_user_button_background_color: "#BE2330",
    existing_user_button_icon: "",
    existing_user_background_image: "",
    existing_user_background_image_alt: "Existing user section background",
    // Download / Brochure section
    download_title: "",
    download_title_color: "#000000",
    download_subtitle: "",
    download_subtitle_color: "#666666",
    download_description: "",
    download_description_color: "#666666",
    brochure_button_text: "Download Brochure",
    brochure_button_text_color: "#FFFFFF",
    brochure_button_background_color: "#BE2330",
    brochure_button_icon: "",
    download_background_image: "",
    download_background_image_alt: "Download section background",
    // Popup display
    popup_display_interval_1: "",
    popup_display_interval_2: "",
    popup_display_interval_3: "",
    enable_delay_form: false,
    enable_exit_form: false,
  },

  LEAD_DROP_POPUP_FIELDS_CONFIG: [
    // Title and header
    {
      fieldName: "form_title",
      label: "Form Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Form Title",
      required: false,
      // isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "form_title_color",
      label: "Form Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Form Title Color (e.g., #000000)",
      required: false,
      // isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "end_date",
      label: "End Date",
      value: "",
      valueType: "string",
      filedType: "DATE",
      placeholder: "Select end date",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "end_time",
      label: "End Time",
      value: "",
      valueType: "string",
      filedType: "TIME",
      placeholder: "Select end time",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "gradient_start",
      label: "Gradient Start Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Start Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "gradient_end",
      label: "Gradient End Color",
      value: "#8B0000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient End Color (e.g., #8B0000)",
      required: false,
      isJsonField: true,
      defaultValue: "#8B0000",
    },
    {
      fieldName: "date_number_color",
      label: "Date Number Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Date Number Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "date_text_color",
      label: "Date Text Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Date Text Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    {
      fieldName: "date_background_color",
      label: "Date Background Color",
      value: "#F5F5F5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Date Background Color (e.g., #F5F5F5)",
      required: false,
      isJsonField: true,
      defaultValue: "#F5F5F5",
    },
    {
      fieldName: "close_icon",
      label: "Close Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Close Icon",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "close_icon_alt",
      label: "Close Icon Alt Text",
      value: "Close",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for close icon",
      required: false,
      isJsonField: true,
      defaultValue: "Close",
    },
    {
      fieldName: "title_2",
      label: "Title 2",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 2",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "title_2_color",
      label: "Title 2 Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title 2 Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
      required: false,
      isJsonField: true,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Description Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    // Button step 1 — the details screen (phone + name + email + qualification
    // + interest). Since this popup captures everything in a single step, this
    // is the ONLY button the user sees before OTP.
    {
      fieldName: "button_step_1_text",
      label: "Button Step 1 Text (Details screen)",
      value: "Sign Up",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Button Step 1 Text",
      required: false,
      isJsonField: true,
      defaultValue: "Sign Up",
    },
    {
      fieldName: "button_step_1_text_color",
      label: "Button Step 1 Text Color (Details screen)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Step 1 Text Color (e.g., #FFFFFF)",
      required: false,
      isJsonField: true,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_background_color",
      label: "Button Background Color (Details screen)",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Background Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    // Button step 2 — THE WHOLE GROUP BELOW (text + both colours) IS INERT.
    // Single-step capture removed the intermediate screen these belonged to; the
    // surviving details screen is driven entirely by the step-1 fields above
    // plus `button_background_color`. Editing anything in this group has no
    // effect on the rendered popup.
    // Kept rather than deleted because the two-step flow is still one flag away:
    // see `showFields` in widgets/leaddrop/leaddrop2/index.tsx.
    {
      fieldName: "button_step_2_text",
      label: "Button Step 2 Text (unused — single-step capture)",
      value: "Continue",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Button Step 2 Text",
      required: false,
      isJsonField: true,
      defaultValue: "Continue",
    },
    {
      fieldName: "button_step_2_text_color",
      label: "Button Step 2 Text Color (unused — single-step capture)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Step 2 Text Color (e.g., #FFFFFF)",
      required: false,
      isJsonField: true,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_step_2_background_color",
      label: "Button Step 2 Background Color (unused — single-step capture)",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Step 2 Background Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    // Button step 3 — the OTP verification screen. NOTE: its text colour must
    // contrast with `button_step_3_background_color`; setting both to the same
    // value renders the label invisible rather than absent.
    {
      fieldName: "button_step_3_text",
      label: "Button Step 3 Text (OTP screen)",
      value: "Submit",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Button Step 3 Text",
      required: false,
      isJsonField: true,
      defaultValue: "Submit",
    },
    {
      fieldName: "button_step_3_text_color",
      label: "Button Step 3 Text Color (OTP screen)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Step 3 Text Color (e.g., #FFFFFF)",
      required: false,
      isJsonField: true,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_step_3_background_color",
      label: "Button Step 3 Background Color (OTP screen)",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Step 3 Background Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    // Checkbox
    {
      fieldName: "checkbox_color",
      label: "Checkbox Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Checkbox Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "checkbox_description",
      label: "Checkbox Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Checkbox Description",
      required: false,
      isJsonField: true,
      defaultValue: "",
      rows: 2,
    },
    {
      fieldName: "checkbox_description_color",
      label: "Checkbox Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Checkbox Description Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    // OTP section
    {
      fieldName: "otp_header_text",
      label: "OTP Header Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter OTP Header Text",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "otp_header_text_color",
      label: "OTP Header Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter OTP Header Text Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "otp_header_description",
      label: "OTP Header Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter OTP Header Description",
      required: false,
      isJsonField: true,
      defaultValue: "",
      rows: 2,
    },
    {
      fieldName: "otp_header_description_color",
      label: "OTP Header Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter OTP Header Description Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    {
      fieldName: "edit_number_text",
      label: "Edit Number Text",
      value: "Edit",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Edit Number Text",
      required: false,
      isJsonField: true,
      defaultValue: "Edit",
    },
    {
      fieldName: "edit_number_text_color",
      label: "Edit Number Text Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Edit Number Text Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "otp_title",
      label: "OTP Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter OTP Title",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "otp_title_color",
      label: "OTP Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter OTP Title Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "resend_otp_text",
      label: "Resend OTP Text",
      value: "Resend OTP",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Resend OTP Text",
      required: false,
      isJsonField: true,
      defaultValue: "Resend OTP",
    },
    {
      fieldName: "resend_otp_text_color",
      label: "Resend OTP Text Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Resend OTP Text Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "otp_description_text",
      label: "OTP Description Text",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter OTP Description Text",
      required: false,
      isJsonField: true,
      defaultValue: "",
      rows: 2,
    },
    {
      fieldName: "otp_description_text_color",
      label: "OTP Description Text Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter OTP Description Text Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    // New user section
    {
      fieldName: "new_user_title",
      label: "New User Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter New User Title",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "new_user_title_color",
      label: "New User Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter New User Title Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "new_user_subtitle",
      label: "New User Subtitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter New User Subtitle",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "new_user_subtitle_color",
      label: "New User Subtitle Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter New User Subtitle Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    {
      fieldName: "new_user_description",
      label: "New User Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter New User Description",
      required: false,
      isJsonField: true,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "new_user_description_color",
      label: "New User Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter New User Description Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    {
      fieldName: "new_user_button_text",
      label: "New User Button Text",
      value: "Continue",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter New User Button Text",
      required: false,
      isJsonField: true,
      defaultValue: "Continue",
    },
    {
      fieldName: "new_user_button_text_color",
      label: "New User Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter New User Button Text Color (e.g., #FFFFFF)",
      required: false,
      isJsonField: true,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "new_user_button_background_color",
      label: "New User Button Background Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter New User Button Background Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "new_user_button_icon",
      label: "New User Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload New User Button Icon",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "new_user_background_image",
      label: "New User Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload New User Section Background Image",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "new_user_background_image_alt",
      label: "New User Background Image Alt Text",
      value: "New user section background",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for new user section background",
      required: false,
      isJsonField: true,
      defaultValue: "New user section background",
    },
    // Existing user section
    {
      fieldName: "existing_user_title",
      label: "Existing User Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Existing User Title",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "existing_user_title_color",
      label: "Existing User Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Existing User Title Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "existing_user_subtitle",
      label: "Existing User Subtitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Existing User Subtitle",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "existing_user_subtitle_color",
      label: "Existing User Subtitle Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Existing User Subtitle Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    {
      fieldName: "existing_user_description",
      label: "Existing User Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Existing User Description",
      required: false,
      isJsonField: true,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "existing_user_description_color",
      label: "Existing User Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Existing User Description Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    {
      fieldName: "existing_user_button_text",
      label: "Existing User Button Text",
      value: "Continue",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Existing User Button Text",
      required: false,
      isJsonField: true,
      defaultValue: "Continue",
    },
    {
      fieldName: "existing_user_button_text_color",
      label: "Existing User Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Existing User Button Text Color (e.g., #FFFFFF)",
      required: false,
      isJsonField: true,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "existing_user_button_background_color",
      label: "Existing User Button Background Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Existing User Button Background Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "existing_user_button_icon",
      label: "Existing User Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Existing User Button Icon",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "existing_user_background_image",
      label: "Existing User Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Existing User Section Background Image",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "existing_user_background_image_alt",
      label: "Existing User Background Image Alt Text",
      value: "Existing user section background",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for existing user section background",
      required: false,
      isJsonField: true,
      defaultValue: "Existing user section background",
    },
    // Download / Brochure section
    {
      fieldName: "download_title",
      label: "Download Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Download Title",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "download_title_color",
      label: "Download Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Download Title Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "download_subtitle",
      label: "Download Subtitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Download Subtitle",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "download_subtitle_color",
      label: "Download Subtitle Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Download Subtitle Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    {
      fieldName: "download_description",
      label: "Download Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Download Description",
      required: false,
      isJsonField: true,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "download_description_color",
      label: "Download Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Download Description Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    {
      fieldName: "brochure_button_text",
      label: "Brochure Button Text",
      value: "Download Brochure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Brochure Button Text",
      required: false,
      isJsonField: true,
      defaultValue: "Download Brochure",
    },
    {
      fieldName: "brochure_button_text_color",
      label: "Brochure Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Brochure Button Text Color (e.g., #FFFFFF)",
      required: false,
      isJsonField: true,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "brochure_button_background_color",
      label: "Brochure Button Background Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Brochure Button Background Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "brochure_button_icon",
      label: "Brochure Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Brochure Button Icon",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "download_background_image",
      label: "Download Section Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Download Section Background Image",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "download_background_image_alt",
      label: "Download Section Background Image Alt Text",
      value: "Download section background",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for download section background",
      required: false,
      isJsonField: true,
      defaultValue: "Download section background",
    },
    // Popup display
    {
      fieldName: "popup_display_interval_1",
      label: "Popup Display Interval 1",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Popup Display Interval 1 (e.g., 3000 - for 3 seconds)",
      required: false,
      isJsonField: true,
      defaultValue: "",
      validation: (value: any, formData: Record<string, any>) => {
        if (formData?.enable_delay_form && (!value || value.toString().trim() === "")) {
          return "Popup Display Interval 1 is required when Enable Delay Form is checked";
        }
        return null;
      },
    },
    {
      fieldName: "popup_display_interval_2",
      label: "Popup Display Interval 2",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Popup Display Interval 2 (e.g., 6000 - for 6 seconds)",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "popup_display_interval_3",
      label: "Popup Display Interval 3",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Popup Display Interval 3 (e.g., 12000 - for 12 seconds)",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "enable_delay_form",
      label: "Enable Delay Form",
      value: false,
      valueType: "boolean",
      filedType: "CHECKBOX",
      placeholder: "Enable form to show after delay",
      required: false,
      isJsonField: true,
      defaultValue: false,
    },
    {
      fieldName: "enable_exit_form",
      label: "Enable Exit Form",
      value: false,
      valueType: "boolean",
      filedType: "CHECKBOX",
      placeholder: "Enable form to show on exit intent",
      required: false,
      isJsonField: true,
      defaultValue: false,
    },
    {
      fieldName: "success_button_link",
      label:
        "Success button link (optional) — opens in a new tab when set; leave empty to keep the current behaviour (closes the popup)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://example.com/... (leave empty to keep current behaviour)",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
  ],

  METADATA_FIELDS: [],
};
